//@flow

import * as React from 'react'
import Lottie from 'lottie-react'
import animationData from './loader.json'
import classnames from 'classnames'

/**
 * @description Base loader definition
 *      USAGE
 *          <Loader
 *              *** PROPS ***
 *          />
 *
 *      PROPS - all props are optional
 *          height    - height of loader
 *          width     - width of loader
 *          className - additional CSS classes
 *
 *      WEB - https://www.npmjs.com/package/lottie-react
 */

type Props = {
    +height?: number,
    +width?: number,
    +className?: ?string
}

export default class Loader extends React.Component<Props> {

    /**
     * Render image loading
     *
     *  @return {React.Node}
     */
    render(): React.Node {
        const {
            height,
            width,
            className,
        } = this.props

        const classes = className || ''

        return (
            <div className={classnames({
                'loader-container': true,
                [classes]: !!classes,
            })}
            >
                <Lottie
                    animationData={animationData}
                    height={height || null}
                    width={width || null}
                />
            </div>
        )
    }
}
